import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { LoginPageComponent } from './components/login-page/login-page.component'
import { EventListComponent } from './components/event-list/event-list.component'
import { EventDetailsComponent } from './components/event-details/event-details.component'
import { PublicAuthGuardService } from './guards/public-auth-guard.service'
import { MyEventListComponent } from './components/my-event-list/my-event-list.component'
import { ProfilePageComponent } from './components/profile-page/profile-page.component'
import { RegisterPageComponent } from './components/register-page/register-page.component'
import { ForgottenPasswordComponent } from './components/forgotten-password/forgotten-password.component'
import { ResetPasswordComponent } from './components/reset-password/reset-password.component'

const routes: Routes = [
  { path: '', redirectTo: 'events', pathMatch: 'full' },
  { path: 'events', component: EventListComponent },
  { path: 'event/:id', component: EventDetailsComponent },
  { path: 'login', component: LoginPageComponent },
  { path: 'register', component: RegisterPageComponent },
  { path: 'forgotten-password', component: ForgottenPasswordComponent },
  { path: 'reset-password/:oobCode', component: ResetPasswordComponent },
  { path: 'my-events', component: MyEventListComponent, canActivate: [PublicAuthGuardService] },
  { path: 'profile', component: ProfilePageComponent, canActivate: [PublicAuthGuardService] },
  { path: '**', redirectTo: 'events', pathMatch: 'full' },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class PublicAppRoutingModule {}
